//import analytics from '../analytics/analytics';
import attrIsTruthy from '../../../../Common/js/util/attributeHelper';
import isFormValid from './is-valid';
import setSlideHeight from './setSlideHeight';

//SetSlideHeight causes page to scroll up upon clicking on a conditional field
//quick solution to deal with the extra soace needed
const setSlidePadding = function (extraFieldsShown) {
    const activeForm = $('.membership-body:not(.inactive)'),
        wrap = activeForm.find('.membership-slides-wrap');

    if(extraFieldsShown) {
        wrap.addClass('extra-pb');
    }else {
        wrap.removeClass('extra-pb');
    }
}

$(() => {
    if ($(".membership").length) {

        $(document).on('click touchend', '.membership-header .form-textfield .autocomplete button', function(e) {
            e.preventDefault();
            $('.membership-header .form-textfield .autocomplete').remove();
            $('.membership-body').removeClass('inactive');
            const $btnEl = $(this);
/*            if ($btnEl.length && attrIsTruthy($btnEl.data('btn-ga-enabled')) && $btnEl.data('ga-config')) {
                analytics.trackDataLayerBtnEvent($btnEl);
            } */
            switchStep(0, true);
            setSlideHeight();
        });

        $('input[name=are-you]').on('change', function(){

            if(this.value === "Partner or Family Member"){
                $('[data-is-family-member="true"]').removeClass('inactive');
                $('[data-is-family-member="false"]').addClass('inactive');
            } else {
                $('[data-is-family-member="true"]').addClass('inactive');
                $('[data-is-family-member="false"]').removeClass('inactive');
            }

            setSlideHeight();
        });

        $('input[name=serviceStatus]').on('change', function(e){
            e.preventDefault();

            if($(this).val() === 'Allied Force'){
                $('[data-service-status-where]').removeClass('inactive');
                setSlidePadding(true);
            }else {
                $('[data-service-status-where]').addClass('inactive');
                setSlidePadding(false);
            }
        });

        $('#diagnosed-condition-13').on('change', function(e){
            e.preventDefault();

            if($(this).val() === 'Other Conditions' && $(this).is(':checked')){
                $('[data-other-conditions]').removeClass('inactive');
                setSlidePadding(true);
            }else {
                $('[data-other-conditions]').addClass('inactive');
                setSlidePadding(false);
            }
        });

        $('input[name=dischargeReason]').on('change', function(e){
            e.preventDefault();

            if($(this).val() === 'Other'){
                $('[data-other-discharge]').removeClass('inactive');
                setSlidePadding(true);
            }else {
                $('[data-other-discharge]').addClass('inactive');
                setSlidePadding(false);
            }
        });

        $("input[type=checkbox][data-copy-container]").on('change', function() {
            var self = $(this).closest('fieldset').find('input[type=text]');
            var copyName = $(this).data('copyContainer');

            if (this.checked && copyName) {
                var copy = $(this).closest('.membership-slides-slide').find('#' + copyName).find('input[type=text]');
                for (var i = 0; i < $(copy).length; i++) {
                    $(self)[i].value = $(copy)[i].value;
                    if ($(self)[i].value) {
                        $(self[i]).parent().removeClass('empty');
                    } else {
                        $(self[i]).parent().addClass('empty');
                    }
                }

                var selfSelect = $(this).closest('fieldset').find('.choices-form-select');
                var copySelect = $(this).closest('.membership-slides-slide').find('#' + copyName).find('.choices-form-select');
                for (var i = 0; i < $(copySelect).length; i++) {
                    let $currentCopyEl = $(copySelect).eq(i);
                    let $currentSelfEl = $(selfSelect).eq(i);
                    let selectedId = "0";
                    if ($currentCopyEl.hasClass("selected")) {
                        $currentSelfEl.addClass("selected");
                        selectedId = $currentCopyEl.find(".choices__list--single .choices__item").attr("data-id");
                    } else {
                        $currentSelfEl.removeClass("selected");
                    }

                    $currentSelfEl.find(".choices").attr("aria-activedescendant", $currentCopyEl.find(".choices").attr("aria-activedescendant"));
                    $currentSelfEl.find("select").html($currentCopyEl.find("select").html());
                    $currentSelfEl.find(".choices__list--single").html($currentCopyEl.find(".choices__list--single").html());
                    if ($currentSelfEl.find(".choices__list div[data-id=" + selectedId + "]").length) {
                        $currentSelfEl.find(".choices__list div[data-id=" + selectedId + "]").attr("aria-selected", "true");
                    }
                }
            } else {
                for (var i = 0; i < $(self).length; i++) {
                    $(self)[i].value = "";
                    $(self[i]).parent().addClass('empty');
                }

                var selfSelect = $(this).closest('fieldset').find('.choices-form-select');
                for (var i = 0; i < $(selfSelect).length; i++) {
                    let $currentSelfEl = $(selfSelect).eq(i);
                    $currentSelfEl.removeClass("selected");

                    $currentSelfEl.find("select").html("<option value=\"\" selected=\"\"></option>");
                    $currentSelfEl.find(".choices__list--single .choices__item--selectable").removeAttr("aria-selected").html("");
                    if ($currentSelfEl.find(".choices__list div[aria-selected=\"true\"]").length) {
                        $currentSelfEl.find(".choices__list div[aria-selected=\"true\"]").removeAttr("aria-selected");
                    }
                }
            }
        });

        $(".membership-tabs__tab").on("click", function(e) {
            e.preventDefault();
            var index = parseInt($(this).find('.membership-tabs__tab--number')[0].innerText) - 1;
            switchStep(index);
        });

        function switchStep(index, dontValidate = false) {
            const activeForm = $('.membership-body:not(.inactive)');

            if (dontValidate === true || isFormValid()) {
                activeForm.find(".membership-tabs__tab").removeClass('active');
                activeForm.find(".membership-slides-slide").each(function(i) {
                    const htmlIndex = i + 1;
                    if (i < index) {
                        $(this).removeClass('active').addClass('done');
                        activeForm.find(".membership-tabs__tab:nth-child("+ htmlIndex + ")").addClass('done');
                    } else if (i == index) {
                        $(this).addClass('active').removeClass('done');
                        activeForm.find(".membership-tabs__tab:nth-child("+ htmlIndex + ")").addClass('active');
                    } else if (i > index) {
                        $(this).removeClass('active').removeClass('done');
                        activeForm.find(".membership-tabs__tab:nth-child("+ htmlIndex + ")").removeClass('done');
                    }
                });
                setSlideHeight();
                $('html,body').animate({ scrollTop: activeForm.offset().top - 140 }, 1000);
            }
        }

        $('.membership-file input[type=file]').on("change", function() {
            var filename = $(this)[0].value.split("\\");
            $(this).next()[0].innerText = filename[filename.length - 1];
        }); 

        $('.change-step').on("click", function(e) {
            e.preventDefault();
            if ($(this).data('step') == 5) {
                $('.membership-tabs__tab:nth-child(5))').removeClass('inactive');
            }
            var step = $(this).data('step') - 1;
            switchStep(step);
        })

        $(window).resize(function() {
            if (window.innerWidth <= 768) {
                $(".membership-tabs__tab:nth-child(2),.membership-tabs__tab:nth-child(3)").addClass('inactive');
                if ($(".membership-slides-slide:nth-child(2)").hasClass('active')) {
                    $(".membership-slides-slide:nth-child(3),.membership-slides-slide:nth-child(4)").addClass('active');
                }
            } else {
                $(".membership-tabs__tab:nth-child(2),.membership-tabs__tab:nth-child(3)").removeClass('inactive');
                if ($(".membership-slides-slide:nth-child(2)").hasClass('active')) {
                    $(".membership-slides-slide:nth-child(3),.membership-slides-slide:nth-child(4)").removeClass('active');
                }
            }
            setSlideHeight();
        });

        function objectifyForm( formId, formHeader, formArray, formFiles) {
            let i; // serialize data function

            const returnArray = {};

            returnArray['areYou'] = $('input[name="are-you"]:checked').val();

            for (i = 0; i < formHeader.length; i++) {
                returnArray[formHeader[i].name] = formHeader[i].value;
            }

            for (i = 0; i < formArray.length; i++) {
                returnArray[formArray[i].name] = formArray[i].value;
            }

            const formData = new FormData();

            formData.append("FormId", formId);
            formData.append("FormData", JSON.stringify(returnArray));

            for (i = 0; i < formFiles.length; i++) {
                formData.append("FileUpload_" + i, formFiles[i].files[0]);
            }

            return formData;
        }

        $('.membership-body button[type=submit]').on("click", function(e) {
            e.preventDefault();
            if (isFormValid()) {
                const activeForm = $('.membership-body:not(.inactive)');
                const formHeader = $(this).closest('.membership').children('.membership-header');
                const formContainer = activeForm.find('.membership-slides');
                const formId = $('#formId').val();
                const formFiles = formContainer.find("input[type=file]");
                const formData = objectifyForm(formId, formHeader.find("input").serializeArray(), formContainer.find("input,select, textarea").serializeArray(), formFiles),
                    $formLoading = $('.membership-loading'),
                    $formLoader = $formLoading.find('.form-loader');

                
                $(".membership-body, .membership-header").addClass('inactive');

                $formLoader.addClass('active');
                $formLoading.removeClass('inactive');

                // Ajax request
                $.ajax({
                    url: $('#membership-form').data('postAction'),
                    method: 'POST',
                    dataType: 'json',
                    contentType: false,
                    processData: false,
                    data: formData,
                    success: function(result) {
                        if (result === '') {
                            $(".membership-thankyou[data-response-type=false]").removeClass('inactive');
                            return;
                        }
                        if (result) {
                            if (result.Status === "Success") {
                                $(".membership-thankyou[data-response-type=true]").removeClass('inactive');
                            } else {
                                $(".membership-thankyou[data-response-type=false]").removeClass('inactive');
                            }
                        }

                        $formLoading.addClass('inactive');
                    }
                }).fail(function(error) {
                    // Failure
                    $(".membership-thankyou[data-response-type=false]").removeClass('inactive');
                    window.console && console.log('error', error);
                    $formLoading.addClass('inactive');
                });

                $('html,body').animate({ scrollTop: $(".membership").offset().top - 140 }, 1000);
            }
        });
    }
});